module.exports = __webpack_public_path__ + "img/vertical_7_7_8003.88e17597.png";